import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Lumber } from '@paragon/contract-library';

const initialState: readonly Lumber[] = [];

const lumberInventoriesSlice = createSlice({
  name: 'lumberInventories',
  initialState,
  reducers: {
    setLumberInventory: (state, action: PayloadAction<readonly Lumber[]>) => action.payload,
  },
});

export const { setLumberInventory } = lumberInventoriesSlice.actions;
export const lumberInventories = lumberInventoriesSlice.reducer;
